import { Component } from 'substance'

export default class BreakComponent extends Component {
  render($$) {
    return $$('br')
  }
}